import { ValidationErrors } from 'final-form';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { Notification } from '@xsolla/ui-core';
import { AlertExclamation } from '@xsolla/ui-icons';

import { FieldInput } from '../../ui';
import { StorageFieldLinks } from './settings';
import { CustomFieldsWrapper } from './style';

type Props = {
  errors: ValidationErrors;
};

const PlayfabFields = ({ errors }: Props): JSX.Element => {
  const intl = useIntl();
  return (
    <CustomFieldsWrapper>
      <Notification
        icon={AlertExclamation}
        palette="brand"
        caption={
          // eslint-disable-next-line react/jsx-wrap-multilines
          <FormattedMessage
            id="user-data-base.settings.user-storage.playfab.notification.description"
            values={{
              ul: (chunk: string) => (
                <ul style={{ padding: '0 0 0 24px', margin: '0' }}>{chunk}</ul>
              ),
              li: (chunk: string) => <li>{chunk}</li>
            }}
          />
        }>
        {intl.formatMessage({
          id: 'user-data-base.settings.user-storage.playfab.notification.title'
        })}
      </Notification>
      <CustomFieldsWrapper>
        <Notification icon={AlertExclamation} palette="brand">
          {intl.formatMessage({
            id: 'user-data-base.settings.user-storage.playfab.title-id.notification'
          })}
        </Notification>
      </CustomFieldsWrapper>
      <CustomFieldsWrapper>
        <FieldInput
          name="playfab_title_id"
          placeholder="F1817B06A4521103"
          label={
            intl.messages[`user-data-base.settings.user-storage.playfab.playfab_title_id.label`]
          }
          extraLink={{
            title:
              intl.messages[`user-data-base.settings.user-storage.playfab.playfab_title_id.link`],
            to: StorageFieldLinks.playfab_title_id
          }}
          errorMessage={intl.messages[errors?.playfab_title_id] as string}
        />
      </CustomFieldsWrapper>
    </CustomFieldsWrapper>
  );
};

export default PlayfabFields;
